import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_CONTENT_EXCEL = "getContentExcel";
export const PAY_WITH_CONTENT_EXCEL = "payWithContentExcel";

//mutation types
export const SET_CONTENT_EXCEL = "setContentExcel";
export const SET_EXCEL_ID = "setExcelId";


export default {
    state: {
        listContentExcel: [],
        excelId: '',

    },
    getters: {
        /**
         * Load list of content excel for payment
         * @param state
         * @returns {*}
         */
        loadedConentExcel(state) {
            return state.listContentExcel;
        },
        /**
         * Load excel id for download
         * @param state
         * @returns {*}
         */
        loadedExcelId(state) {
            return state.excelId;
        },

    },
    actions: {
        /**
         * Get list of content excel for payment
         * @param state
         * @param payload
         */
        [GET_CONTENT_EXCEL](context, payload) {

            if (payload !== 'cancele') {
                return new Promise((resolve, reject) => {
                    httpHelper
                        .getData('sharing-api/get-excel-file/' + payload)
                        .then((response) => {
                            context.commit(SET_CONTENT_EXCEL, response.result)
                            context.commit(SET_EXCEL_ID, payload)
                            resolve(response)
                        }).catch((error) => {
                            reject(error)
                        })
                });
            } else {
                context.commit(SET_CONTENT_EXCEL, []);
                context.commit(SET_EXCEL_ID, '');
            }

        },
        /**
         * pay with excel list
         * @param state
         * @param payload
         */
        [PAY_WITH_CONTENT_EXCEL](context, payload) {
            if (payload !== 'cancele') {
                return new Promise((resolve, reject) => {
                    httpHelper
                        .postData('sharing-api/transfer-from-excel/' + payload.gatewayId, { 'fileId': payload.fileId })
                        .then((response) => {
                            resolve(response)
                        }).catch((error) => {
                            reject(error)
                        })
                });
            } else {
                context.commit(SET_CONTENT_EXCEL, []);
                context.commit(SET_EXCEL_ID, '');
            }

        },
    },

    mutations: {
        /**
         * insert respone of request in state
         * @param state
         * @param payload
         */
        [SET_CONTENT_EXCEL](state, payload) {
            state.listContentExcel = [...payload];
        },
        /**
         * insert excel id for downlaod in state
         * @param state
         * @param payload
         */
        [SET_EXCEL_ID](state, payload) {
            state.excelId = payload;
        },

    }
};